/* eslint-disable camelcase */
// node modules
import React from 'react';

// app modules: services
import { isApp } from 'services/environment';

// app modules: components
import Layout from 'components/Layout';
import ContentView from 'components/ContentView';
import MeteredAccess from 'components/MeteredAccess';
import SwipeableContentView from './SwipeableContentView';

async function action({ query, store, isGoogleBot }, params) {
  const state = store.getState();

  const enableSwipeableViews =
    isApp() ||
    ((state.user?.permissions?.includes('feature:swipenav') ||
      state.featureUsage.toggles.swipeNav !== false) &&
      state.user.subscription?.is_valid);

  const enableSidebarAd =
    state.featureUsage.toggles.sidebarAd &&
    !state.user.subscription?.is_valid &&
    state.adverts.visible &&
    state.dimensions.displayType !== 'mobile';

  const props = {
    id: params.id,
    type: params.type,
    token: query.token,
    isInitialPage: state.router.isInitialPage,
    disableAnimation: state.router.locationState.animate !== true,
    enableSidebarAd,
  };
  return {
    chunks: ['content'],
    navigation: {
      section: null,
      left: 'back',
      center: null,
    },
    component: enableSwipeableViews ? (
      <Layout
        type="full"
        hideToolbarOnScroll={!state.user.home_connect_enabled}
        withLeaderboardAd={false}
        withFooterLeaderboardAd={false}
        enableSidebarAd={enableSidebarAd}
      >
        <SwipeableContentView className="layout--normal" slideClassName="layout__body" {...props} />
        {/* MeteredAccess uses a fixed position. It needs to be outside the 
            swipeable layout to ensure that the viewport is its containing block */}
        <MeteredAccess />
      </Layout>
    ) : (
      <Layout
        type="normal"
        hideToolbarOnScroll={!state.user.home_connect_enabled}
        withLeaderboardAd={false}
        withFooterLeaderboardAd={false}
        enableSidebarAd={enableSidebarAd}
      >
        <ContentView forceSsr={isGoogleBot} {...props} />
        <MeteredAccess />
      </Layout>
    ),
  };
}

export default action;
